// extracted by mini-css-extract-plugin
export var dividerContainer = "_6j-0";
export var line = "_6j-1";